import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import {alpha, useTheme} from '@mui/material/styles';
import MenuIcon from '@mui/icons-material/Menu';
import Link2 from '@mui/material/Link';
import {NavItem} from './components';
import {ThemeModeToggler} from "../index";
import AccountMenu from '../../../../containers/Navbar/AccountMenu'
import {useSelector} from 'react-redux'
import {isLoaded, isEmpty} from 'react-redux-firebase'


function Greeting(props) {
    const isLoggedIn = props.isLoggedIn;
    if (isLoggedIn) {
        return <AccountMenu/>
    }
    return <Fragment/>
}

const Topbar = ({onSidebarOpen, pages, colorInvert = false}) => {
    const theme = useTheme();
    const {mode} = theme.palette;
    const {
        landings: landingPages,
    } = pages;

    const auth = useSelector(state => state.firebase.auth)
    const authExists = isLoaded(auth) && !isEmpty(auth)

    return (
        <Box
            display={'flex'}
            justifyContent={'space-between'}
            alignItems={'center'}
            width={1}
        >
            <Box
                display={'flex'}
                component="a"
                href="/"
                title="theFront"
                width={{xs: 210, md: 210}}
            >
                <Box
                    component={'img'}
                    src={
                        mode === 'light' && !colorInvert
                            ? 'https://github.com/app-divaga/gobierno-web-Docs/blob/main/logovector.png?raw=true'
                            : 'https://github.com/app-divaga/gobierno-web-Docs/blob/main/logovector.png?raw=true'
                    }
                    height={1}
                    width={1}
                />
            </Box>
            <Box sx={{display: {xs: 'none', md: 'flex'}}} alignItems={'center'}>
                <Box marginLeft={4}>
                    <Link2
                        underline="none"
                        component="a"
                        href="https://tuxtepec.gob.mx/"
                        color="text.primary"
                    >
                        Inicio
                    </Link2>
                </Box>
                
                <Box marginLeft={4}>
                    <Link2
                        underline="none"
                        component="a"
                        href="/"
                        color="text.primary"
                    >
                        Presupuesto Participativo
                    </Link2>
                </Box>


                <Box marginLeft={4}>

                    <ThemeModeToggler/>

                </Box>
                <Box marginLeft={3}>
                    <Greeting isLoggedIn={authExists}/>

                </Box>

            </Box>
            <Box sx={{display: {xs: 'block', md: 'none'}}} alignItems={'center'}>
                <Button
                    onClick={() => onSidebarOpen()}
                    aria-label="Menu"
                    variant={'outlined'}
                    sx={{
                        borderRadius: 2,
                        minWidth: 'auto',
                        padding: 1,
                        borderColor: alpha(theme.palette.divider, 0.2),
                    }}
                >
                    <MenuIcon/>
                </Button>
            </Box>
        </Box>
    );
};

Topbar.propTypes = {
    onSidebarOpen: PropTypes.func,
    pages: PropTypes.object,
    colorInvert: PropTypes.bool,
};

export default Topbar;
